// extracted by mini-css-extract-plugin
export var emailBlockLink = "_jv-0";